export default __webpack_public_path__ + "locales/sr-Cyrl-RS/DeleteThirdPartyDialog.json?hash=b04fd35e91cb2ee084c8c73e942bacdf";